import React from 'react';
import {
	Container,
	SpaceBetween,
	ColumnLayout,
	Header,
} from '@amzn/awsui-components-react-v3';
import { KeyValue } from 'src/components/commonComponents/KeyValue';
import { ReviewStepProps } from './reviewForm.interface';
import { useFormContext } from 'react-hook-form';

export default function ReviewStep({
	requirements,
	header,
	taskId = null,
}: ReviewStepProps) {
	const { getValues } = useFormContext();
	const workflowRequirementsData = getValues();
	const dataToDisplay = workflowRequirementsData[taskId ?? 'EntityData'] ?? {};

	const predefinedValues = Object.fromEntries(
		requirements
			.filter(req => req.value && req.attributeName)
			.map(req => [req.attributeName, req.value])
	);

	const mergedData = { ...predefinedValues, ...dataToDisplay };

	return (
		<Container
			header={<Header>{header}</Header>}
			data-testid={`${taskId ?? 'common'}-review-container`}
		>
			<ColumnLayout columns={4} variant="text-grid" borders="all">
				<SpaceBetween size="l">
					{requirements.map(({ attributeName }) => (
						<KeyValue label={attributeName!} key={attributeName!}>
							{JSON.stringify(
								workflowRequirementsData![attributeName!] || mergedData![attributeName!]
							)}
						</KeyValue>
					))}
				</SpaceBetween>
			</ColumnLayout>
		</Container>
	);
}
